export default require.context(process.env.VUE_APP_VIEW_DIR, true, /\.js|\.ts$/)
